import React from 'react';
import { AIBadge } from '../../AiBadge';
import { motion } from 'framer-motion';
import { FeaturesSection } from './FeaturesSection';

export const CareerResourcesSection = (): JSX.Element => {
  return (
    <section className="flex flex-col w-full items-center justify-center gap-1 py-20 bg-white">
      <div className="flex flex-col w-full items-start gap-10">
        <div className="flex flex-col w-full items-start gap-8 px-8 py-0">
          <motion.div
            className="flex flex-col items-center gap-12 w-full"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.18, ease: 'easeOut', type: 'tween' }}>
            <div className="flex flex-col max-w-[768px] items-center gap-3">
              <div className="flex flex-col items-center gap-3 w-full">
                <div className="inline-flex items-start">
                  <div className="inline-flex items-center gap-3 pl-1 pr-2.5 py-1 rounded-2xl">
                    <div className="inline-flex items-center">
                      <AIBadge title="AI for Hiring" />
                    </div>
                  </div>
                </div>

                <h2 className="m-0 w-full font-sans font-semibold text-[36px] leading-[44px] tracking-[-0.02em] text-center text-gray-900">
                  <span>Hire faster with&nbsp;</span>
                  <span className="text-primary">AI-powered</span>
                  <span>&nbsp;matching</span>
                </h2>
              </div>

              <p className="m-0 max-w-[768px] font-sans font-light text-[20px] leading-[30px] tracking-normal text-center text-gray-600">
                Find the perfect candidates with intelligent screening and automated workflows.
              </p>
            </div>
          </motion.div>
        </div>
        <motion.div
          className="flex flex-col items-center gap-8 w-full"
          initial={{ opacity: 0, y: 40, scale: 1.05 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.48, ease: 'easeOut', type: 'tween' }}>
          <div className="flex items-start justify-center w-full max-w-[904px] h-[414.83px] relative">
            <div className="relative w-[830px] h-[380.11px]">
              <div className="absolute top-[5px] left-[223px] w-[530px] h-[355px] rounded-[6.83px] border-[2.73px] border-solid border-[#181d27]">
                <div className="absolute w-[calc(100%_-_44px)] h-[calc(100%_-_6px)] top-0 left-[19px] bg-[#181d27] shadow-[0px_21.84px_43.68px_-8.19px_#0a0c1224]" />
                <div className="absolute w-[calc(100%_-_6px)] h-[calc(100%_-_6px)] top-0 left-0 rounded-[6.83px] border-[0.68px] border-solid border-neutral-100 [background:url(https://c.animaapp.com/mibc0aags5LdA5/img/screen-mockup--replace-fill-.png)_50%_50%_/_cover]" />
              </div>

              <div className="absolute top-[41px] left-[107px] w-[167px] h-[339px]">
                <div className="absolute w-[89.71%] h-[95.31%] top-[2.23%] left-[5.02%] bg-white overflow-hidden">
                  <div className="absolute w-full h-full top-[3.94%] left-0 [background:url(https://c.animaapp.com/mibc0aags5LdA5/img/screen-mockup--replace-fill--1.png)_50%_50%_/_cover]" />
                  <div className="absolute w-full h-[4.68%] top-0 left-0 flex gap-[92.4px]">
                    <img
                      className="mt-[6.8px] w-[11.33px] h-[4.42px] ml-[13.3px]"
                      alt="Date"
                      src="https://c.animaapp.com/mibc0aags5LdA5/img/date.png"
                    />
                    <img
                      className="mt-[6.9px] w-[26.56px] h-[4.52px]"
                      alt="Right"
                      src="https://c.animaapp.com/mibc0aags5LdA5/img/right.png"
                    />
                  </div>
                  <div className="absolute top-[310px] left-0 w-[149px] h-3.5 flex items-end">
                    <div className="mb-[2.7px] w-[53.39px] h-[1.99px] ml-[32.27%] mr-[32%] flex-1 bg-black rounded-[39.84px]" />
                  </div>
                </div>
                <img
                  className="absolute w-full h-[99.77%] top-0 left-0"
                  alt="Iphone mockup"
                  src="https://c.animaapp.com/mibc0aags5LdA5/img/iphone-mockup.svg"
                />
              </div>
            </div>
          </div>
          <FeaturesSection />
        </motion.div>
      </div>
    </section>
  );
};
